<template>

<div>
    <nav-bar-home></nav-bar-home>
	<main id="main" class="cart">
		
		<section class="cart-content parten-bg">
			<div class="container">
				
				<div class="row cart-header" style="margin-top:15px;">
					<div class="col-md-6 col-sm-10 cart-title">
						<h1>Shopping cart ({{ userCartItems.length }})</h1>
						<p>If you have any queries, our Customer Services team will be happy to help — just email us: <a href="mailto:customerservice@vestigobrandsolutions.com">customerservice@vestigobrandsolutions.com</a></p>
					</div>
					<!-- <div class="col-md-3 col-sm-2 continue-shopping">
						<a href="#" title="Continue shopping">
							Continue Shopping 
							<i class="fa fa-arrow-circle-o-right"></i>
						</a>
					</div> -->
				</div><!-- Cart title : End -->
				<div class="row">
					<!--Cart main content : Begin -->
					<section class="cart-main col-md-9 col-xs-12">
						<!--Cart Item-->
						<p class="visible-xs mobile-cart-title">There are 2 items in your cart.</p>
						<div class="table-responsive">
                            <table cellspacing="0" class="table-cart table" style="margin-top:15px;">
                                <thead >
                                    <tr>
                                        <th class="product-info" style="width: 55%;">Products</th>
                                        <th class="product-price">Price</th>
                                        <th class="product-quantity">Qty</th>
                                        <th class="product-discount"> Discount</th>
                                        <th class="product-discount"> Total Price</th>
                                        <!-- <th class="product-wishlist">Move to wishlist</th> -->
                                        <!-- <th class="product-subtotal">Total</th> -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="cart_item" v-for="(item, index) in userCartItems" :key="item._id">
                                        <td class="product-info">
                                            <div class="product-image-col">
                                                <a class="product-image" title="product card">
													<img class="cart-images" :src="$store.state.URL+'/uploads/product/'+item.product.image"  v-if="item?.product?.image">
													<img class="cart-images" :src="$store.state.URL+'/uploads/artworks/'+item.artwork" v-else>
                                                    <!-- <img :src="$store.state.URL+'/uploads/product/'+item.product.image" alt="product card"> -->
                                                </a>
                                                <div class="product-action ">
                                                        <!-- <a href="#" class="cart-edit" title="Edit Product">
                                                                <i class="fa fa-pencil-square-o"></i>
                                                        </a> -->
                                                        <a href="#" class="cart-delete" title="Delete Product" @click="removeCartItem(item)">
                                                                <i class="fa fa-times"></i>
                                                        </a>
                                                        <!-- <a href="#" class="cart-update" title="Update Product">
                                                                <i class="fa fa-refresh"></i>
                                                        </a> -->
                                                </div>
                                        </div>
                                        <div class="product-info-col">
											<h3 class="product-name">{{ item.product ? item.product.productName : `${item.quote_id.quotesProduct} (${item.quote_id.quoteNumber})` }} </h3>
                                                <ul class="pro-option" v-if="item.opData">
                                                        <li v-if="item.opData.bookletPagination !== ''">
                                                                <span class="pro-opt-label">Booklet Pagination: </span>
                                                                <span class="pro-opt-value">{{ item.opData.bookletPagination }}</span>
                                                        </li>
														<li v-if="item.opData.bookletType !== ''">
                                                                <span class="pro-opt-label">Booklet Type: </span>
                                                                <span class="pro-opt-value">{{ item.opData.bookletType }}</span>
                                                        </li>
														<li v-if="item.opData.foldingOption !== ''">
                                                                <span class="pro-opt-label">Folding Option: </span>
                                                                <span class="pro-opt-value">{{ item.opData.foldingOption }}</span>
                                                        </li>
														<li v-if="item.opData.printed !== 'None'">
                                                                <span class="pro-opt-label">Print Sides: </span>
                                                                <span class="pro-opt-value">{{ item.opData.printed }}</span>
                                                        </li>
														<li v-if="item.opData.productPaperSizeFormat !== ''">
                                                                <span class="pro-opt-label">Paper Size: </span>
                                                                <span class="pro-opt-value">{{ item.opData.productPaperSizeFormat }}</span>
                                                        </li>
														<li v-if="item.opData.productPaperTypeWeight !== ''">
                                                                <span class="pro-opt-label">Paper Weight: </span>
                                                                <span class="pro-opt-value">{{ item.opData.productPaperTypeWeight }}</span>
                                                        </li>
														<li v-if="item.opData.material !== ''">
                                                                <span class="pro-opt-label">Material: </span>
                                                                <span class="pro-opt-value">{{ item.opData.material }}</span>
                                                        </li>
														<!-- <li v-if="item.quantity.quantity !== ''">
                                                                <span class="pro-opt-label">Order Quantity: </span>
                                                                <span class="pro-opt-value">{{ item.quantity.quantity }}</span>
                                                        </li> -->
														<li v-if="item.product.deliveryTurnaround !== ''">
                                                                <span class="pro-opt-label">Delivery: </span>
                                                                <span class="pro-opt-value">{{ item.product.deliveryTurnaround }}</span>
                                                        </li>                                                       
                                                         <li class="product-price hidden-lg hidden-md hidden-sm">
                                                             <span class="pro-opt-label">Price:</span>
                                                             <span class="pro-opt-value"  style="color: #25bce9;">&euro;  {{ Number(item.quantity.sellingProductPrice).toFixed(2) }}</span>
                                                        </li>
                                                </ul>
												<ul class="pro-option" v-else>
													<li v-if="item.quote_id !== ''">
                                                        <span class="pro-opt-label">Quote ID No: </span>
                                                        <span class="pro-opt-value">{{ item.quote_id.quoteNumber }}</span>
                                                    </li>	
													<li v-if="item.quote_id !== ''">
                                                    	<span class="pro-opt-label">Quote Description: </span>
                                                        <span class="pro-opt-value">{{ item.quote_id.suppliersDesription }}</span>
                                                    </li>

												</ul>
                                        </div>
                                        </td>
                                        <td class="product-price ">
                                            <span>&euro;  {{ customRoundTwoDecimals(item.quantity.sellingProductPrice) }}</span>
                                        </td>
                                        <td class="product-quantity "> 
											<span>{{ item.quantity.quantity }}</span>
                                        	<!-- <input type="number"  v-model="item.quantity" name="qty" id="qty" style="width: 100px;"> -->
                                        </td>
                                        <td class="product-discount "> 
                                            &euro;  {{ item.quote_id
												? $LFT(Number(item.quantity.sellingProductPrice))
												: $LFT(
													Number(item.discountPCPAm)
													+
													Number(item.discountPromoCodeAm)
													+
													((Number(item.quantity.sellingProductPrice) * Number(item.spendDiscount)) / 100)
													)
												}}

											<br>
											<span v-if="item.discountPCP"> PCP Applied: &euro; 
												{{ $LFT(item.discountPCPAm ) }} 
											</span>
											<!-- <br>
											<span v-if="item.discountPromoCode"> Promotion Applied: &euro; 
												{{ $LFT(item.discountPromoCodeAm ) }} </span><br>
												<span v-if="spendDiscount"> Spend Applied: &euro; 
												{{ $LFT((item.quantity.sellingProductPrice * spendDiscount) / 100) }} </span>	 -->
                                        </td>
                                        <!-- <td class="product-wishlist hidden-xs checkbox-w">
                                        	<input type="checkbox" id="addWishlist01" name="move-wishlist" checked>
                                        	<label for="addWishlist01" class="clearfix">
                                        		<i class="fa fa-square-o"></i>
                                        		<i class="fa fa-check-square-o"></i>
                                        	</label>
                                        </td> -->
                                        <td class="product-subtotal ">
                                        	<span style="color: rgb(86, 108, 215);">&euro; {{ item.quote_id ? customRoundTwoDecimals(item.quantity.sellingProductPrice) :
												$LFT(
													$calculateSubtotal(item.quantity.sellingProductPrice, [
														item.discountPCPAm,
														item.discountPromoCodeAm,
														(item.quantity.sellingProductPrice * item.spendDiscount) / 100,
													])
												)  }} </span>
                                        </td>										
                                    </tr>
                                    
                                </tbody>
                            </table>
                        </div>
						<!--Cart Item-->
						<!-- <div class="row update-wishlist">
							<div class="col-sm-12 hidden-xs">
								<button type="button" name="update-wishlist" class="gbtn btn-update-wishlist">
									<i class="fa fa-refresh"></i>
									Update Wishlist
								</button>
							</div>
						</div> -->
						<div class="row cart-bottom">
						
							<div class="col-sm-6 discount-code clearfix">
								<h3>Discount Codes</h3>
								<p>Do you have a promotional code?</p>
								<form action="#" method="POST" name="discount-code">
									<div class="form-group">
    									<input type="text" class="form-control" v-model="PROMOCODE" id="discountCode" placeholder="Promo Code" :disabled="preferentialMessage.isDisabled">
									</div>
									<button  class="gbtn btn-discount" @click.prevent="checkPromo">Apply Coupon</button>
									<span class="text-danger" v-if="userCartItems.length > 0">
										{{ preferentialMessage.message }}
									 </span>
								</form>
							</div><!--Discount Code: End-->
							<div class="col-sm-6 subtotal clearfix">
								<h3>Sub total</h3>
								<p>Checkout with Multiple Addresses</p>
								<ul>
									<!-- <li>
										<span class="sub-title">Sub Total</span>
										<span class="sub-value">&euro; 20.26</span>
									</li>  -->

									<li class="grand-total">
										<span class="sub-title">Sub Total</span>
										<span class="sub-value" style="color: rgb(86, 108, 215);">&euro; {{ customRoundTwoDecimals(total) }} </span>
									</li>
									<li class="grand-total">
										<span class="sub-title">VAT</span>
										<span class="sub-value" style="color: rgb(86, 108, 215);">&euro; {{ $LFT(VAT) }} </span>
									</li><li class="grand-total">
										<span class="sub-title">Grand Total</span>
										<span class="sub-value" style="color: rgb(86, 108, 215);">&euro; {{ $LFT(grandtotal) }} </span>
									</li>
								</ul>
								<button type="button" class="gbtn btn-checkout" @click="proceedCheckout">Proceed Checkout</button>
							</div>
						</div>
					</section><!-- Cart main content : End -->
					<!--Cart right banner: Begin-->
					<section class="col-sm-3 cart-right-banner hidden-sm hidden-xs">
						<div class="cart-right-banner">
							<a href="#" title="cart right banner">
								<img src="/images/banner/cart/cart-banner.png" alt="cart right banner">
							</a>
						</div>
					</section>
					<!--Cart right banner: End-->
				</div>
				
			</div>
		</section>
	</main><!-- Main Category: End -->
	<!--Footer : Begin-->
    <footer-section></footer-section>
  </div>
</template>

<script>
import moment from 'moment'
import NavBarHome from "@/components/NavBarHome.vue"
import FooterSection from "@/components/FooterSection.vue"
import {mapState} from 'vuex'
import { getApplicablePcpDiscountPercent } from '@/utils/pcpDiscount'
export default {
components:{NavBarHome, FooterSection},
data(){
	return {
		PROMOCODE:'',
		promoError:'',
	}
},
computed:{
	...mapState(['user','userCart','userCartItems','userPCP','userOrders']),
	// ((item.product.sellingProductPrice / item.product.quantity ) * item.quantity)
	// (( ((item.product.sellingProductPrice / item.product.quantity ) * item.quantity) * item.discountPCP ) / 100 )
	// (( ((item.product.sellingProductPrice / item.product.quantity ) * item.quantity) * item.discountPromoCode ) / 100 )
	completedOrders(){
		if (this.userOrders) {
			let orders = this.userOrders.filter((order) => { return order.isOrderPaid });
			return orders;
		}else{
			return []
		}
	},
	completedOrdersSpend(){
		if (this.completedOrders) {
			let orders = 0;
			this.completedOrders.forEach(element => {
				element.items.forEach(elm => {
					orders += elm.quantity.sellingProductPrice 
				});
			});
			
			return orders;
		}else{
			return 0
		}
	},
	spendDiscount(){
		if ( this.completedOrdersSpend ) {
			let am = 0;
			if (this.completedOrdersSpend >1999 ) am += 2 
			if (this.completedOrdersSpend >2999 ) am += 2
			return am 
		} else {
			return 0
		}
	},
	grandtotal(){
		return Number(this.total) + Number(this.VAT)
	},
	total(){
		if (this.userCartItems.length) {

			let total = 0;

			this.userCartItems.forEach(element => {
				total += element.quote_id
					? this.$roundCurrency(element.quantity.sellingProductPrice)
					: this.$calculateSubtotal(element.quantity.sellingProductPrice, [
						element.discountPCPAm,
						element.discountPromoCodeAm,
						element.spendDiscountAm,
					]);
			});

			return this.customRoundTwoDecimals(total)
		}
		return 0;
	},
	VAT(){
		if (this.userCartItems.length) {

			let total = 0;

			this.userCartItems.forEach(element => {
				const totals = element.quote_id
						? this.$roundCurrency(element.quantity.sellingProductPrice)
						: this.$calculateSubtotal(element.quantity.sellingProductPrice, [
							element.discountPCPAm,
							element.discountPromoCodeAm,
							element.spendDiscountAm,
						]);

						 let vatOrPrice = this.$getItemVatRate(element);

				let tt = this.$calculateVat(totals, vatOrPrice)
				total += Number(tt)
			});

			return Number(total.toFixed(2))
		}
		return 0;
	},
	preferentialMessage() {
		let message = '';
		let isDisabled = false;

		// Always prioritize showing promoError if it exists
		if (this.promoError) {
			message = this.promoError;
			isDisabled = false; // An error doesn't necessarily disable the input; allow retrying
			return { message, isDisabled };
		}

		// Original logic for PCP if no promoError
		if (this.userCartItems.length === 1) {
			isDisabled = this.userCartItems[0].discountPCP > 0;
			message = isDisabled ? 'Preferential Pricing agreements already applied on product.' : '';
		} else if (this.userCartItems.length > 1) {
			let anyItemHasPCP = false;
			for (let item of this.userCartItems) {
			if (item.discountPCP > 0) {
				anyItemHasPCP = true;
				break;
				}
			}
			isDisabled = anyItemHasPCP;
			message = anyItemHasPCP ? 'Preferential Pricing agreements already applied on product.' : '';
		}
		
		return { message, isDisabled };
	},
},
async mounted(){
	await this.$store.dispatch("getPcps")
	setTimeout(() => {
		this.checkDiscounts()
	}, 3000);
},
methods:{
	async removeCartItem(item){
		console.log("removing cart item", item)
		await this.$store.dispatch("removeCartItem",{item})
		await this.$store.dispatch("getUser")
		
	},
	handleQtyChange(index){
		let num = Number(this.$store.state.userCartItems[index].quantity)
		console.log(num)
		if (num) {
			this.$store.state.userCartItems[index].price = ((this.$store.state.userCartItems[index].product.sellingProductPrice / this.$store.state.userCartItems[index].product.quantity ) *  num)
		}
		
	},
	async proceedCheckout(){
		let cartItems = [];
		this.userCartItems.forEach(element => {
			cartItems.push({
				id: element._id,
				discountPCP: element.discountPCP,
				discountPromoCode: element.discountPromoCode,
				discountPCPAm: element.discountPCPAm,
				discountPromoCodeAm: element.discountPromoCodeAm,
				spendDiscount: this.spendDiscount,
				spendDiscountAm: Number(((element.quantity.sellingProductPrice * this.spendDiscount) / 100).toFixed(2)),
				promoCode: element.promoCode,
				// total:Number(this.total + this.VAT),
				// quantity: element.quantity,
			})
		});
		let dec = await this.$store.dispatch("updateCartItems", {items: cartItems})
		if (dec.status) {
			this.$router.push({path:'/checkout'})
		}
	},
	async checkPromo(){
		this.promoError = ''; // Clear previous errors
		let isDiscountAppliedToAnyItem = false; // Flag to track if any discount was applied to an item

		// Reset all existing promo codes on cart items before re-checking
		this.$store.state.userCartItems.forEach(cartItem => {
			cartItem.discountPromoCode = 0;
			cartItem.promoCode = '';
			cartItem.discountPromoCodeAm = 0;
		});

		let dec = await this.$store.dispatch("checkPromo", { code: this.PROMOCODE });
		if (dec.status) { // Coupon code exists and is generally valid based on API response
			if (moment().isBetween(dec.code.startAt, dec.code.endAt)) { // Coupon is within its valid date range

				// Attempt to apply discount
				if (dec.code.discountOn == 'selected') {
					if (dec.code.products && dec.code.products.length > 0) {
						this.$store.state.userCartItems.forEach((cartItem, index) => {
							// Check if the current cart item's product ID is in the promo code's selected products list
							if (cartItem.product && dec.code.products.includes(cartItem.product._id)) {
								if (!cartItem.discountPromoCode) { // Only apply if no promo discount already set for this item
									this.$store.state.userCartItems[index].discountPromoCode = dec.code.discount;
									this.$store.state.userCartItems[index].promoCode = dec.code.code;
									this.$store.state.userCartItems[index].discountPromoCodeAm = 
										(cartItem.quantity.sellingProductPrice * dec.code.discount) / 100;
									isDiscountAppliedToAnyItem = true;
								}
							}
						});
					}
				} else { // discountOn is 'all' or similar
					this.$store.state.userCartItems.forEach((cartItem, index) => {
						if (!cartItem.discountPromoCode) { // Only apply if no promo discount already set for this item
							this.$store.state.userCartItems[index].discountPromoCode = dec.code.discount;
							this.$store.state.userCartItems[index].promoCode = dec.code.code;
							this.$store.state.userCartItems[index].discountPromoCodeAm = 
								(cartItem.quantity.sellingProductPrice * dec.code.discount) / 100;
							isDiscountAppliedToAnyItem = true;
						}
					});
				}

				// After attempting to apply, check if any discount was actually applied
				if (!isDiscountAppliedToAnyItem) {
					this.promoError = "This coupon code is not applicable to any items in your cart.";
				}

			} else {
				this.promoError = "The coupon code is expired or not yet active.";
			}
		} else {
			this.promoError = dec.message || "Invalid coupon code."; // Use API message or a generic fallback
		}
	},
	async checkDiscounts(){
		await this.$store.dispatch("getPcps")

		this.$store.state.userCartItems.forEach((elm, index) => {
			const productId = elm.product ? elm.product._id : null
			const discountPercent = getApplicablePcpDiscountPercent(this.userPCP, productId)
			this.$store.state.userCartItems[index].discountPCP = discountPercent
			this.$store.state.userCartItems[index].discountPCPAm = discountPercent
				? ((this.$store.state.userCartItems[index].quantity.sellingProductPrice * discountPercent) / 100)
				: 0
		});
	},
	customRoundTwoDecimals(value) {
		const rounded = Math.round(value);
		return rounded.toFixed(2);
	}
},
}

</script>

<style>
.mapouter{position:relative;text-align:right;height:100%;width:100%;}
.gmap_canvas {overflow:hidden;background:none!important;height:100%;width:100%;}
.cart-images{
	max-width: 100%;
}

/* 2 Sept 2025 */
.cart_item a.product-image {
    max-width: 100%;
    width: 100%;
    display: block;
    max-height: 200px;
    height: 100%;
    aspect-ratio: 1;
}
.cart_item a.product-image img{
	width: 100%;
	height: 100%;
	object-fit: contain;
}

@media(max-width:767px){
	.table-responsive {
  width: 100%;
  overflow-x: auto;   /* enables horizontal scroll */
  -webkit-overflow-scrolling: touch; /* smooth scroll on mobile */
}

.table-responsive table {
  width: max-content;  /* prevent table from shrinking */
  min-width: 100%;     /* ensures at least full width */
  border-collapse: collapse;
}
.table-cart.table td{
	white-space: nowrap!important;
}
td.product-info {
    max-width: 100%;
    display: flex;
    flex-direction: column;
}

}


</style>